import React from 'react';
import { Line } from 'react-chartjs-2';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

const StudentActiveChart = (props) => {
  const { t, months, activeStudentQuantity, contectedPlan } = props;

  const data = {
    labels: months,
    datasets: [
      {
        label: t(
          'dashboard.occupationBoard.charts.studentActives.legends.contractedPlan'
        ),
        fill: false,
        lineTension: 0.4,
        backgroundColor: '#D4a3ee',
        borderColor: '#D4a3ee',
        borderWidth: 3,
        pointBackgroundColor: '#D4a3ee',
        pointHoverRadius: 1,
        pointHoverBorderWidth: 1,
        pointRadius: 3,
        pointHitRadius: 1,
        data: contectedPlan,
      },
      {
        label: t(
          'dashboard.occupationBoard.charts.studentActives.legends.studentActives'
        ),
        fill: false,
        lineTension: 0.4,
        backgroundColor: '#01E4D7',
        borderColor: '#01E4D7',
        borderWidth: 3,
        pointBackgroundColor: '#01E4D7',
        pointHoverRadius: 3,
        pointHoverBorderWidth: 1,
        pointRadius: 3,
        pointHitRadius: 1,
        data: activeStudentQuantity,
      },
    ],
  };

  const legendOptions = {
    display: true,
    position: 'bottom',
    onClick: () => {},
  };

  const options = {
    scales: {
      xAxes: [
        {
          gridLines: {
            color: '#E7E7ED',
          },
          ticks: {
            fontColor: '#30313F',
            stepSize: 10,
          },
        },
      ],
      yAxes: [
        {
          gridLines: {
            color: '#E7E7ED',
          },
          ticks: {
            fontColor: '#30313F',
            stepSize: 10,
          },
        },
      ],
    },

    maintainAspectRatio: false,

    plugins: {
      datalabels: false,
    },
  };

  return <Line data={data} legend={legendOptions} options={options} />;
};

StudentActiveChart.propTypes = {
  t: PropTypes.func.isRequired,
  months: PropTypes.arrayOf(PropTypes.shape).isRequired,
  activeStudentQuantity: PropTypes.arrayOf(PropTypes.shape).isRequired,
  contectedPlan: PropTypes.arrayOf(PropTypes.shape).isRequired,
};

export default withTranslation('common')(StudentActiveChart);
